import service from '@/store/services/biotimes/biotime-syncs-service';

const state = {
    list: {},
    biotimeSync: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, biotimeSync) => {
        state.biotimeSync = biotimeSync;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(biotimeSync => {
                commit('SET_RESOURCE', biotimeSync);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(biotimeSync => {
                commit('SET_RESOURCE', biotimeSync);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((biotimeSync) => {
                commit('SET_RESOURCE', biotimeSync);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((biotimeSync) => {
                commit('SET_RESOURCE', biotimeSync);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    biotimeSync: state => state.biotimeSync,
    dropdown: (state) => {
        return state.list.map(biotimeSync => ({
            id: biotimeSync.id,
        }));
    }
};

const biotimeSyncs = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default biotimeSyncs;
